<template>
	<div>
		<Breadcrumbs main="Service Management" title="Edit Complaint" />
			<div class="container-fluid">
				<div class="row">
				   	<div class="col-sm-12">
						<div class="card">
							<div class="card-body">
	
								<div class="row mb-3">
									<div class="col-12">
										<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
									</div>
								</div>
	
								<form  @submit.prevent="updateComplaint" enctype="multipart/form-data">
									<div class="form theme-form">
										<div class="row">
											<div class="col-md-3">
												<div class="mb-3 position-relative">
													<label class="control-label">Select Device<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Search IMEI or Vehicle No or Mobile" v-model="device_id" @input="searchDevice" @focus="showSuggestions = true" @blur="hideSuggestions" autocomplete="off" />
													<div v-if="errors.device_id" class="text-danger">{{ errors.device_id }}</div>
													<ul v-if="showSuggestions && deviceSuggestions.length" class="list-group position-absolute w-100" style="z-index: 10; max-height: 200px; overflow-y: auto;">
														<li v-for="(dev, idx) in deviceSuggestions" :key="dev.imei" class="list-group-item list-group-item-action" @mousedown.prevent="selectDevice(dev)">
															<div><strong>{{ dev.imei }}</strong> - {{ dev.vehicle_no }} - {{ dev.mobile }}</div>
														</li>
													</ul>
												</div>
											</div>

											<div class="col-md-3 form-group">
												<label class="control-label">Complaint Type<span class="text-danger">*</span></label>
												<select class="form-select" v-model="complaint_type">
													<option value="">Select</option>
													<option value="1">SIM Change</option>
													<option value="2">Repair</option>
													<option value="3">Replacement</option>
												</select>
												<div v-if="errors.complaint_type" class="text-danger">{{ errors.complaint_type }}</div>
											</div>

											<div class="col-md-3">
												<div class="mb-3">
													<label class="control-label">Vehicle Number<span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="Enter vehicle number" v-model="vehicle_no"/>
													<div v-if="errors.vehicle_no" class="text-danger">{{ errors.vehicle_no }}</div>
												</div>
											</div>

										</div>

										<div class="row">
											<div class="col-12">
												<div class="mb-3">
													<label class="control-label">Complaint Details<span class="text-danger">*</span></label>
													<textarea class="form-control" placeholder="Enter complaint details" v-model="complaint_data"></textarea>
													<div v-if="errors.complaint_data" class="text-danger">{{ errors.complaint_data }}</div>
												</div>
											</div>
										</div>
										<div class="row mt-3">
											<div class="col-sm-12">
												<button class="btn btn-success me-2 float-end" type="submit" :disabled="submitting">
													<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
													{{ submitting ? "Saving..." : "Save" }}
												</button>
											</div>
										</div>
		
									</div>
								</form>
							</div>
						</div>
				   	</div>
				</div>
			</div>
 
	</div>
 </template>

<script>
	export default {
		name: "Add Campaign Page",
		

		data() {
			return {
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				submitting: false,
				errors: {},

				button_title: "Save",

				id:"",
				device_id: "",
				vehicle_no: "",
				complaint_data: "",
				complaint_type: "",
				searchTimeout: null,
				deviceSuggestions: [],
				selectedDevice: null,
				showSuggestions: false,
				complaint_id: null,

				
			};
		},
		created() {
			this.complaint_id = this.$route.params.id;
			this.fetchComplaintDetails();
		},
		mounted() {
			const imei = this.$route.query.imei;
			if (imei) {
				this.device_id = imei;
				this.searchDevice();
			}
		},
		
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff = JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {
						this.token = airotrack_staff.token;
						this.user = airotrack_staff;
					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}
				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchComplaintDetails() {
				this.getToken();
				
				this.$axios
					.get('/staffs/serviceDetail', {
						params: {
							service_id: this.complaint_id
						},
						headers: { 
							Authorization: "Bearer " + this.token
						}
					})
					.then((response) => {
						if (response.data.status === 'true') {
							const complaint = response.data.data;
							console.log('Fetched complaint details:', complaint);
							
							// Populate form fields with existing data
							this.id =complaint.device_id;
							this.device_id = complaint.device.imei || '';
							this.vehicle_no = complaint.vehicle_no || '';
							this.complaint_data = complaint.details || '';
							this.complaint_type = complaint.service_type || '';
							
							// If device_id exists, try to find and select the device
							if (this.device_id) {
								this.findAndSelectDevice(this.device_id);
							}
						} else {
							this.$swal('Error', 'Complaint not found', 'error');
							this.$router.push({ name: 'complaint_management' });
						}
					})
					.catch((error) => {
						console.error('Error fetching complaint details:', error);
						this.$swal('Error', 'Failed to load complaint details', 'error');
						this.$router.push({ name: 'complaint_management' });
					});
			},

			findAndSelectDevice(deviceId) {
				// Search for the specific device to populate device details
				this.getToken();
				this.$axios
					.get("staffs/deviceLists", {
						params: { keyword: deviceId },
						headers: {
							Authorization: `Bearer ${this.token}`,
						},
					})
					.then((response) => {
						if (response.data.status === 'true' && response.data.data.length > 0) {
							// Find the exact device match
							const device = response.data.data.find(d => d.imei === deviceId);
							if (device) {
								this.selectedDevice = device;
								// Update vehicle_no if it's different from the stored one
								if (!this.vehicle_no) {
									this.vehicle_no = device.vehicle_number;
								}
							}
						}
					})
					.catch((error) => {
						console.error("Error fetching device details:", error);
					});
			},

			searchDevice() {
				if (!this.device_id.trim()) {
					this.deviceSuggestions = [];
					this.showSuggestions = false;
					return;
				}

				if (this.searchTimeout) clearTimeout(this.searchTimeout);

				this.searchTimeout = setTimeout(() => {
					this.getToken(); // Get token before making API call
					const searchTerm = this.device_id.trim();
					this.$axios
						.get("staffs/deviceLists", {
							params: { keyword: searchTerm },
							headers: {
								Authorization: `Bearer ${this.token}`,
							},
						})
						.then((response) => {
							if (response.data.status === 'true') {
								this.deviceSuggestions = response.data.data;
								this.showSuggestions = true;
							} else {
								this.deviceSuggestions = [];
								this.showSuggestions = false;
							}
						})
						.catch((error) => {
							console.error("Error fetching device list:", error);
							this.deviceSuggestions = [];
							this.showSuggestions = false;
						});
				}, 300);
			},

			selectDevice(device) {
				this.device_id = device.imei;
				this.vehicle_no = device.vehicle_number;
				this.selectedDevice = device;
				this.deviceSuggestions = [];
				this.showSuggestions = false;
			},

			hideSuggestions() {
				setTimeout(() => {
					this.showSuggestions = false;
				}, 200);
			},

			updateComplaint() {
				if (this.submitting) return;
				// Validate required fields
				this.errors = {};
				let isValid = true;

				if (!this.device_id || this.device_id.trim() === '') {
					this.errors.device_id = 'Device selection is required';
					isValid = false;
				}

				if (!this.complaint_type) {
					this.errors.complaint_type = 'Complaint type is required';
					isValid = false;
				}

				if (!this.vehicle_no || this.vehicle_no.trim() === '') {
					this.errors.vehicle_no = 'Vehicle number is required';
					isValid = false;
				}

				if (!this.complaint_data || this.complaint_data.trim() === '') {
					this.errors.complaint_data = 'Complaint details are required';
					isValid = false;
				}

				if (!isValid) {
					return;
				}

				this.submitting = true;
				this.getToken();
				
				const formData = {
					service_id: this.$route.params.id,
					device_id: this.device_id,
					service_type: this.complaint_type,
					vehicle_number: this.vehicle_no,
					details: this.complaint_data
				};

				this.$axios
					.post('/staffs/updateService', formData, {
						headers: {
							'Authorization': 'Bearer ' + this.token,
							'Content-Type': 'application/json'
						}
					})
					.then((response) => {
						if (response.status === 200) {
							this.$swal('Success', 'Complaint updated successfully', 'success');
							this.$router.push({ name: 'complaint_management' });
						}
					})
					.catch((error) => {
						console.error('Error updating complaint:', error);
						this.$applyApiFieldErrors(this.errors, error);
						this.$swal('Error', this.$getApiErrorMessage(error, 'Failed to update complaint. Please try again.'), 'error');
					})
					.finally(() => {
						this.submitting = false;
					});
			},
				
			clearForm() {
				this.edit = false;
				this.errors = {};
			},

		},
	};

</script>